/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update the phone of a person
 * @export
 * @interface UpdatePhonePwrRequest
 */
export interface UpdatePhonePwrRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePhonePwrRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePhonePwrRequest
     */
    prefixPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePhonePwrRequest
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePhonePwrRequest
     */
    isMobile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePhonePwrRequest
     */
    isFavorite?: boolean;
}

/**
 * Check if a given object implements the UpdatePhonePwrRequest interface.
 */
export function instanceOfUpdatePhonePwrRequest(value: object): value is UpdatePhonePwrRequest {
    return true;
}

export function UpdatePhonePwrRequestFromJSON(json: any): UpdatePhonePwrRequest {
    return UpdatePhonePwrRequestFromJSONTyped(json, false);
}

export function UpdatePhonePwrRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePhonePwrRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'] == null ? undefined : json['phone'],
        'prefixPhone': json['prefixPhone'] == null ? undefined : json['prefixPhone'],
        'note': json['note'] == null ? undefined : json['note'],
        'isMobile': json['isMobile'] == null ? undefined : json['isMobile'],
        'isFavorite': json['isFavorite'] == null ? undefined : json['isFavorite'],
    };
}

export function UpdatePhonePwrRequestToJSON(json: any): UpdatePhonePwrRequest {
    return UpdatePhonePwrRequestToJSONTyped(json, false);
}

export function UpdatePhonePwrRequestToJSONTyped(value?: UpdatePhonePwrRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
        'prefixPhone': value['prefixPhone'],
        'note': value['note'],
        'isMobile': value['isMobile'],
        'isFavorite': value['isFavorite'],
    };
}

